"use client"

import SectionWrapper from "@/components/common/section-wrapper"
import { Button } from "@/components/ui/button"
import { Card, CardContent } from "@/components/ui/card"
import { Checkbox } from "@/components/ui/checkbox"
import { Label } from "@/components/ui/label"
import {
  generateId,
  generateNotValidId,
  generateValidId,
} from "@/lib/generateId"
import { cn } from "@/lib/tailwind-utils"
import Image from "next/image"
import { useRouter } from "next/navigation"
import { useState } from "react"
import Swal from "sweetalert2"

function calculateScore(score, total) {
  return (score / total) * 100
}

function checkAnswers(examData, userAnswers) {
  let score = 0
  const answers = examData.map((question, idx) => {
    const isCorrect = userAnswers[idx + 1] === question.trueAnswer
    if (isCorrect) {
      score++
    }
    return {
      no: idx + 1,
      userAnswer: userAnswers[idx + 1],
      trueAnswer: question.trueAnswer,
      isCorrect: isCorrect,
    }
  })

  return { score, answers }
}

export default function Quiz({ exams, subTrainingCode, isTraining }) {
  const router = useRouter()
  const [userAnswer, setUserAnswer] = useState({})
  const [isCheckedPerizinan, setCheckedPerizinan] = useState(false)
  const { answers: finalAnswer, score } = checkAnswers(exams, userAnswer)
  const isDone = Object.keys(userAnswer).length === 10
  const finalScore = calculateScore(score, exams.length)

  const handleUserAnswer = (no, examValue) => {
    setUserAnswer({
      ...userAnswer,
      [no]: examValue,
    })
  }

  const resetAnswer = () => {
    setUserAnswer({})
    setCheckedPerizinan(false)
    router.refresh()
  }

  const handleFinalAnswerQuiz = () => {
    if (!isTraining) {
      if (finalScore !== 100) {
        return Swal.fire({
          icon: "error",
          title: "Anda Gagal dalam Test Buta Warna",
          text: `Maaf, Anda tidak bisa melanjutkan untuk mendaftar pelatihan!`,
          timerProgressBar: true,
          timer: 3000,
        })
      }

      return Swal.fire({
        icon: "success",
        title: "Anda Berhasil melewati Test Buta Warna",
        text: `Selamat, Anda bisa melanjutkan untuk mendaftar pelatihan!`,
        timerProgressBar: true,
        timer: 3000,
      })
    }

    if (finalScore !== 100) {
      return Swal.fire({
        icon: "error",
        title: "Anda Gagal dalam Test Buta Warna",
        text: `Sayang sekali Anda gagal tes buta warna, silahkan pastikan kembali kesehatan mata Anda dengan dokter atau ahli mata`,
        timerProgressBar: true,
        timer: 3000,
      }).then(() => {
        return router.replace(
          `/pelatihan/${String(subTrainingCode).toLowerCase()}/daftar?sessionId=${generateNotValidId()}`,
        )
      })
    }

    return Swal.fire({
      icon: "success",
      title: "Anda Berhasil dalam Test Buta Warna",
      text: `Selamat, Anda berhasil tes buta warna. Namun, tetap pastikan kesehatan mata Anda dengan mendatangi dokter atau ahli mata!`,
      timerProgressBar: true,
      timer: 3000,
    }).then(() => {
      return router.replace(
        `/pelatihan/${String(subTrainingCode).toLowerCase()}/daftar?sessionId=${generateValidId()}`,
      )
    })
  }

  return (
    <SectionWrapper
      className={"space-y-5 max-w-screen-lg flex flex-col items-end"}>
      <div className="flex gap-x-5 gap-y-5 md:gap-y-0 w-full flex-col md:flex-row md:items-end items-start justify-between">
        <div className="space-y-5">
          <div className="space-y-3 md:space-y-0">
            <Label className="block text-destructive font-bold md:text-[16px] md:leading-[24px]">
              * Tes ini bertujuan untuk mengetahui kelayakan kondisi Anda untuk
              mengikuti Pelatihan
            </Label>
            <Label className="block text-destructive font-bold md:text-[16px] md:leading-[24px]">
              * Anda harus mendapatkan skor 100 agar dapat melanjutkan
              pendaftaran
            </Label>
          </div>
          <div>
            <Label className="block font-bold  md:text-[16px] md:leading-[24px]">
              Petunjuk Pengerjaan :
            </Label>
            <Label className="block md:text-[16px] md:leading-[24px]">
              Pilihan dengan cara mengklik angka yang benar dari 3 (tiga)
              pilihan jawaban.
            </Label>
          </div>
        </div>
        <Button
          className="bg-destructive hover:bg-destructive/90"
          type="button"
          onClick={resetAnswer}>
          Reset Jawaban
        </Button>
      </div>
      <div className="flex flex-col  gap-y-5 w-full">
        <div className="flex flex-col gap-y-5 w-full">
          {exams.map((exam, index) => {
            return (
              <Card key={exam?.id}>
                <CardContent className="p-5">
                  <div className="flex gap-x-10 md:flex-row flex-col gap-y-5 md:gap-y-0 items-center md:items-start">
                    <div>
                      <Image
                        alt=""
                        src={exam?.image}
                        width={200}
                        height={200}
                        priority
                        className="object-cover"
                      />
                      <span className="text-[9px] italic">
                        Sumber : {exam?.source}
                      </span>
                    </div>
                    <div className="space-y-5 ">
                      <h1 className="font-bold text-txt18_20 md:text-txt30_40">
                        Soal No.{index + 1}
                      </h1>
                      <div className="flex gap-x-5">
                        {exam?.options.map((opt) => {
                          return (
                            <div
                              key={opt?.id}
                              className="flex items-center gap-x-3">
                              <Label className="block text-txt18_20 md:text-txt20_30">
                                {opt?.name} .{" "}
                              </Label>
                              <Button
                                type="button"
                                className={cn(
                                  "md:text-[20px]  text-[18px] leading-[20px] md:leading-[30px] bg-color-4 border hover:bg-color-4/70",
                                  {
                                    "bg-white text-color-4 border-color-4 ":
                                      userAnswer[index + 1] === opt?.name,
                                  },
                                )}
                                onClick={(e) => {
                                  e.preventDefault()
                                  e.stopPropagation()
                                  handleUserAnswer(index + 1, opt?.name)
                                }}>
                                {opt?.value}
                              </Button>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>
            )
          })}
        </div>
        <div className="space-y-5">
          <div className="flex items-center space-x-2">
            <Checkbox
              id="terms2"
              disabled={!isDone}
              checked={isCheckedPerizinan}
              onCheckedChange={setCheckedPerizinan}
            />
            <Label
              htmlFor="terms2"
              className="text-txt16_24 text-wrap font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
              *Dengan ini saya menyatakan telah mengerjakan tes buta warna
              mandiri tanpa bantuan dari orang lain
            </Label>
          </div>

          <Button
            onClick={() => {
              if (!isTraining) {
                resetAnswer()
              }
              handleFinalAnswerQuiz()
            }}
            disabled={!isDone || !isCheckedPerizinan}
            type="button"
            className="bg-destructive hover:bg-destructive/90 w-[200px]">
            Akhiri Tes
          </Button>
        </div>
      </div>
    </SectionWrapper>
  )
}
